"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MerchDisplay: ()=>MerchDisplay_MerchDisplay
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_PlainA_index_cjs_namespaceObject = require("../PlainA/index.cjs");
const external_PlainButton_index_cjs_namespaceObject = require("../PlainButton/index.cjs");
const external_MerchDisplay_variants_cjs_namespaceObject = require("./MerchDisplay.variants.cjs");
const renderBrand = (brandNode, brandSlot)=>{
    if (!brandNode) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: brandSlot(),
        children: brandNode
    });
};
const renderSavings = (savings, savingsSlot)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: savingsSlot(),
        children: savings
    });
const renderBody = (body, bodySlot)=>{
    if (!body) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: bodySlot(),
        children: body
    });
};
const renderAction = (action, actionSlot)=>{
    if (!action?.text) return null;
    const commonStyleProps = {
        'aria-label': action.ariaLabel,
        type: 'primary',
        emphasis: 'regular',
        textStyle: 'body3'
    };
    let actionElement;
    actionElement = 'href' in action ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainA_index_cjs_namespaceObject.PlainA, {
        href: action.href,
        target: action.target,
        rel: '_blank' === action.target ? action.rel || 'noopener noreferrer' : action.rel,
        onClick: action.onClick,
        ...commonStyleProps,
        children: action.text
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainButton_index_cjs_namespaceObject.PlainButton, {
        buttonType: "button",
        onClick: action.onClick,
        ...commonStyleProps,
        children: action.text
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: actionSlot(),
        children: actionElement
    });
};
const MerchDisplay_MerchDisplay = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function(props, ref) {
    const { brandNode, savings, body, action, alignment, savingsType, className, ...restProps } = props;
    const variants = (0, external_MerchDisplay_variants_cjs_namespaceObject.merchDisplayVariants)({
        alignment,
        savingsType
    });
    const { rootSlot, headerSlot, brandSlot, savingsSlot, bodySlot, actionSlot } = variants;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        ref: ref,
        className: (0, index_cjs_namespaceObject.cn)(rootSlot(), className),
        ...restProps,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: headerSlot(),
                children: [
                    renderBrand(brandNode, brandSlot),
                    renderSavings(savings, savingsSlot)
                ]
            }),
            renderBody(body, bodySlot),
            renderAction(action, actionSlot)
        ]
    });
});
exports.MerchDisplay = __webpack_exports__.MerchDisplay;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MerchDisplay"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
